
import React from 'react';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';

import Component from '../../components/Component';

export default class ConfirmDeleteDocumentModal extends Component
{
  	render()
  	{
  		if (!this.props.document) {
  			return <div/>;
  		}
		let title = TB.tryTrans('documents.delete.title'),
			message = TB.tryTrans('documents.delete.confirm_message', {name: this.props.document.display_name}),
			cancel_btn = TB.tryTrans('documents.delete.cancel'),
			submit_btn = TB.tryTrans('documents.delete.submit');
	    return (
	      	<div>
		        <Modal isOpen={this.props.isVisible}
		        	toggle={this.props.toggle}>
		          	<ModalBody>
		          		<div className="flex"
		          			style={{justifyContent: 'space-between', alignItems: 'center'}}>

							<p className="mb-0" style={{fontWeight: 500}}>
								{title}
							</p>

							<button type="button"
								style={{fontSize: 16, padding: 10, textAlign: 'right'}}
								className="btn"
								onClick={this.props.toggle}>
								<i className="fa fa-times-circle"/>
							</button>
						</div>
		          		<p style={{fontSize: 12}}>
							{message}
		            	</p>
		          	</ModalBody>
		          	<ModalFooter className="mx-auto">
			            <button type="button"
			            	className="btn btn-outline-primary"
			              	onClick={() => this.props.toggle(false)}
			              	disabled={this.props.isDisabled}>
							{cancel_btn}
			            </button>
			            <button type="button"
			            	className="btn btn-primary"
			              	onClick={() => this.props.onConfirm(this.props.document)}
			              	disabled={this.props.isDisabled}>
							{submit_btn}
			            </button>
		          	</ModalFooter>
		        </Modal>
	      	</div>
	    );
  	}
}